/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Storefront filters (collection and search pages).
 *
 * The filter form is a plain GET form, so it still works with JavaScript disabled through its
 * "Apply filters" button. When JavaScript is available we submit as soon as a checkbox changes
 * so filtering feels instant. Price range inputs are left to the "Apply filters" button, since
 * their change event fires on blur and would submit before both ends have been entered.
 *
 * The theme applies sorting over Ajax without re-rendering the filter form, so sort_by is read
 * back from the address bar first — otherwise filtering would silently revert the chosen sort.
 */
document.addEventListener('change', function(event) {
  if (event.target.type !== 'checkbox') {
    return;
  }

  var form = event.target.closest('[data-storefront-filters]');

  if (!form) {
    return;
  }

  var sortInput = form.querySelector('[data-storefront-filters-sort]'),
      sortBy = new URL(window.location.href).searchParams.get('sort_by');

  if (sortInput && sortBy) {
    sortInput.value = sortBy;
  }

  form.submit();
});
